import React, { FC } from "react";
import { CheckboxStyled } from "./elements";

type CheckboxProps = {
  children: React.ReactNode;
  disabled?: boolean;
  onChange: (e:any) => void;
  checked?: boolean;
};

const Checkbox: FC<CheckboxProps> = (props) => {
  const { children, onChange, disabled, checked } = props;

  return (
    <CheckboxStyled checked={checked} onChange={onChange} disabled={disabled || false}>
      {children}
    </CheckboxStyled>
  );
};

export default Checkbox;
